import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import occupationService from './service'

const initialState = {
  _payload: null,
  status: 'idle',
  error: '',
  data: [],
}

const adapter = (payload) => {
  let result = []

  if(payload && payload.length > 0){
    for (let index = 0; index < payload.length; index++) {
      const data = payload[index];
      result.push({
        id: data.id,
        name: {
          id: data.nama[0],
          en: data.nama[1]
        }
      })
    }
  }

  return result
}

export const fetchOccupations = createAsyncThunk('occupation/fetchOccupations', async (dispatch) => {
  const list = await occupationService.getAll()
  return list
})

export const occupationSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
  },
  extraReducers: {
    [fetchOccupations.pending]: (state) => {
      state.status = 'loading'
    },
    [fetchOccupations.fulfilled]: (state, action) => {
      state.status = 'succeeded'
      state.data = adapter(action.payload)
      state._payload = action.payload
    },
    [fetchOccupations.rejected]: (state, action) => {
      state.status = 'failed'
      state.error = action.error.message
    }
  }
})

export default occupationSlice.reducer
